<template>
  <div class="baseContent-warp">
    <Card>
      <span slot="title">密码修改</span>
      <el-form slot="content" ref="modifyPwdForm" :rules="rules" :model="modifyPwdForm" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="modifyPwdForm.oldPassword" placeholder="原密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="modifyPwdForm.newPassword" placeholder="新密码" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="checkNewPwd">
          <el-input v-model="modifyPwdForm.checkNewPwd" placeholder="确认新密码" />
        </el-form-item>
        <el-form-item class="mt30">
          <el-button icon="el-icon-edit" type="primary" @click="submitForm('modifyPwdForm')">保存修改</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm('modifyPwdForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </Card>
  </div>
</template>

<script lang="js">
import { validatePwd } from "@/utils/regexp" // 自定义验证
import { PasswordModify } from "@/api/account"; // 引入修改密码api
export default {
  data() {
    // 自定义验证确认新密码
    const checkConfirmPwd = (rule, value, callback) => {
      if (value !== this.modifyPwdForm.newPassword) callback(new Error("两次密码不一致哦"));
      else callback();
    };
    return {
      modifyPwdForm: { oldPassword: "", newPassword: "", checkNewPwd: "" },
      rules: { // 验证规则
        oldPassword: [{ required: true, validator: validatePwd, trigger: 'blur' }],
        newPassword: [{ required: true, validator: validatePwd, trigger: 'blur' }],
        checkNewPwd: [
          { required: true, validator: validatePwd, trigger: 'blur' },
          { required: true, validator: checkConfirmPwd, trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    // 重置表单
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 修改密码
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { code } = await PasswordModify(this.modifyPwdForm.newPassword, this.modifyPwdForm.oldPassword, this.$session.get('user').userId);
          if (code == 200) {
            this.$message.success('密码修改成功，即将在3秒后退出系统，请重新登录！');
            setTimeout(() => {
              this.$session.clear();
              this.$router.push("/login");
            }, 3000);
          }
        } else return;
      });
    },
  },
};
</script>